import axios from "axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { form } from "../types/Forms";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

interface FormResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: form[];
}

const fetch = (authHeader: string, type?: "individual" | "entity") => () => {
  const baseUrl = `${env.verifyServiceUrl}individual/form/`;
  const url = type ? `${baseUrl}?_type=${type}` : baseUrl;

  return axios.get<FormResponse>(url, {
    headers: { Authorization: authHeader },
  });
};

export const useForms = (type?: "individual" | "entity") => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery(["forms", type ?? "all"], fetch(authHeader, type), {
    retry: false,
    select: (response) => response.data.results,
    onError: (err: any) => {
      const status = err?.request?.status ?? err?.response?.status;
      if (status === 500 || status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      } else if (status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    },
  });
};
